module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAZCAYAAADTyxWqAAAAAXNSR0IArs4c6QAAANJJREFUOBHtULsNgzAQtRNEi8QESClYgUkYhJZFKBkiTboMkYYRmIAqcd5R4JN8PpzUPunE4/1knTEn45yrsXf6nlh1GQUl9omloW+pJxQV4Zla2MyKPS6hYGQlHI7xlKAg2WM/vIFh4nshFlIwdtiNhSVIehemGQNDg12ltMCRr2FxDyFU2JcQ0ijyV74FCESBfWgpRaNccRTiZ1LMKdK0l8E5pLgTPIOF6YbW6/FMDxYPA9QGjDFvK5A7RS+JaRYjaReJ/JfLZb9fLt8s3yxygS/GodmPKvf2NgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ups.png
// module id = cRRq
// module chunks = 1